// extracted by mini-css-extract-plugin
export default {"formWrapper":"item-details-tab_formWrapper__CyxC6","actionBtnWrapper":"item-details-tab_actionBtnWrapper__eOgEQ","nextBtn":"item-details-tab_nextBtn__EGjJd"};